export const ALLOWED_WIDTHS = [
  128, 160, 200, 320, 400, 600, 1920, 2256,
] as const

export function resizedUploadsHelper(
  filename: string | undefined,
  width: (typeof ALLOWED_WIDTHS)[number],
) {
  if (!filename) return ''
  if (!ALLOWED_WIDTHS.includes(width)) return ''

  const matches = filename.match(/^(.+?)(\.(png|jpg|jpeg|gif|svg))?$/)

  if (!matches) return
  const filename2 = matches[1]
  const extension = matches[2].toLowerCase()

  return `/images/${width}/${filename2}${extension}`
}
